module.exports = __webpack_public_path__ + "img/check-solid.99a1ebf9.svg";